import React from 'react';

import PropTypes from 'prop-types';

import Actions from './Actions';
import getLocalFormattedTime from './utils';

const Row = ({ order, fetchOrders, header }) => {
  const { orderId, ccBusinessLegalName, createdAt, updatedAt, status } = order;

  return (
    <tr>
      <td data-header-label={header[0]}>{orderId}</td>
      <td data-header-label={header[1]}>{ccBusinessLegalName}</td>
      <td data-header-label={header[2]}>{status}</td>
      <td data-header-label={header[3]}>{getLocalFormattedTime(createdAt)}</td>
      <td data-header-label={header[4]}>{getLocalFormattedTime(updatedAt)}</td>
      <td data-header-label={header[5]}>
        <div className="responsive-table__actions">
          <Actions status={status} order={order} fetchOrders={fetchOrders} />
        </div>
      </td>
    </tr>
  );
};

Row.propTypes = {
  order: PropTypes.objectOf(PropTypes.object).isRequired,
  fetchOrders: PropTypes.func.isRequired,
  header: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default Row;
